<template>
<!-- 收款完成业务 --对应menu收款登记-已收款-->
  <BusinessList
    :tabPanelData="tabList"
    :statusIn="4"
    :marketFeeCanCommand="false"
    :FilterFieldProps="FilterField"
    :approvalParams="{
      receivedStatus: 3
    }"
    :showSummary="true"
    businessTypeName="TABLE_RECEIVED_DONE_BUSINESS"
    pageTypeIn="RECEIVED_DONE"
    :summaryField=[]
  />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import { FilterField } from './FilterField'

export default defineComponent({
  name: 'Receivedbusines',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        // { name: '联系人', id: 1 },
        // { name: '市场费', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      FilterField
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
